import { accountsTypesForOperations, accountsFamiliesForOperations, accountsCurrenciesOperation, accountsNaturesOperation, accountsComponentExcludedForOperations, accountsNaturesExcludedForOperations } from '@/assets/scripts/mappers/accounts'
import { routeList } from '@/router/helpers/routes'
import { ACCOUNT_TYPES } from '@/assets/constants/accounts'

/* Filters accounts for a specific feature
@accountsList { array } - list of accounts
@returns { array } - returns accounts available for this route feature
*/
export const parseAccountsForFeature = (accountsList) => {
    const currentRoutePath = window.location.hash.replace('#', '').split('?')[0]
    const routePathKey = Object.keys(routeList).find(key => routeList[key] === currentRoutePath)
    const mapperRoute = routePathKey.replace('_PATH', '')

    /* We first checking if there's no accounts, if not, we simply return the empty array we just received */
    if (!accountsList?.length) return []

    let allAccounts = accountsList

    /* Validate if there's a filter by type for this operation, if so we filter the array */
    if (accountsTypesForOperations[mapperRoute]) {
        const allowedTypes = accountsTypesForOperations[mapperRoute]
        allAccounts = allAccounts.filter(account => { return allowedTypes.find(type => { return type === (account.accountType || account.type) }) })
    }

    /* Validate if there's a filter by currency for this operation, if so we filter the array */
    if (accountsFamiliesForOperations[mapperRoute]) {
        const allowedFamilies = accountsFamiliesForOperations[mapperRoute]
        allAccounts = allAccounts.filter(account => { return allowedFamilies.find(family => { return family === account.accountFamily }) })
    }

    /* Validate if there's a filter to exclude certain types of operations, if so we filter the array */
    if (accountsComponentExcludedForOperations[mapperRoute]) {
        const allowedFamilies = accountsComponentExcludedForOperations[mapperRoute]
        allAccounts = allAccounts.filter(account => { return allowedFamilies.find(family => { return family !== account.component }) })
    }

    /* Validate if there's a filter by currency for this operation, if so we filter the array */
    if (accountsCurrenciesOperation[mapperRoute]) {
        const allowedCurrencies = accountsCurrenciesOperation[mapperRoute]
        allAccounts = allAccounts.filter(account => { return allowedCurrencies.find(currency => { return currency === account.currency }) })
    }

    /* Validate if there's a filter by nature for this operation, if so we filter the array */
    if (accountsNaturesOperation[mapperRoute]) {
        const accountsNatures = accountsNaturesOperation[mapperRoute]
        allAccounts = allAccounts.filter(account => {
            const accountNature = account.accountNumber.slice(9, 11)
            return accountsNatures.find(nature => { return nature === accountNature })
        })
    }

     /* Validate if there's a filter by nature to exclude for this operation, if so we filter the array */
     if (accountsNaturesExcludedForOperations[mapperRoute]) {
        const accountsNatures = accountsNaturesExcludedForOperations[mapperRoute]
        allAccounts = allAccounts.filter(account => {
            const accountNature = account.accountNumber.slice(9, 11)
            return !accountsNatures.includes(accountNature)
        })
    }

    /* Next we will validate if filter removed the default account from our array of accounts if so, we will define a new one */
    if (allAccounts.length && !allAccounts.find((obj) => obj.default)) {
        allAccounts[0].default = true
    }

    return allAccounts
}

/* Credits and term deposits are financial-product accounts: the bank identifies them by the product
name plus the unique operation reference (agency + operation code + sequence), never by the account
number, so their lists must show those two lines instead of description/accountNumber (issue #113775)
@account { object } - a single account from the accounts service
*/
export const isProductAccount = (account) => {
    const accountType = account?.accountType || account?.type
    return accountType === ACCOUNT_TYPES.CR || accountType === ACCOUNT_TYPES.DP
}

/* First line of a product account: the friendly product name (falls back to the account description
when the service does not send the product) */
export const productAccountName = (account) => {
    if (!isProductAccount(account)) return account?.description
    return account.product?.name || account.description
}

/* Second line of a product account: the unique operation reference (falls back to the account number
when the service does not send it) */
export const productAccountReference = (account) => {
    if (!isProductAccount(account)) return account?.accountNumber
    return account.externalReference || account.accountNumber
}
